'use client';

import Image from 'next/image';

import { Typography } from '@gds/Typography/Typography';
import { useSavedSearchForm } from '@plp/Components/SavedSearch/UseSavedSearchForm';
import { useInitAggregations } from '@search/Hooks/UseInitAggregations';

import type { SavedSearchProps } from './SavedSearchCta.entity';

import styles from './SavedSearchCta.module.css';

export function SavedSearchCta({ strings, make, model, locale }: SavedSearchProps) {
  useInitAggregations();
  const { openForm, canUseSavedSearch } = useSavedSearchForm({
    locale,
    strings,
    defaultFilters: [
      {
        id: 'make',
        value: [make],
      },
      {
        id: 'model',
        value: [model],
      },
    ],
  });

  if (!canUseSavedSearch) {
    return null;
  }

  return (
    <button className={styles.wrapper} onClick={openForm}>
      <Image src="/img/Bell.svg" alt="Bell Icon" objectFit="contain" height={'40'} width={'40'} />

      <Typography variant="button3">
        {strings.savedSearchStrapLine} <u>{strings.signUp}</u>
      </Typography>
    </button>
  );
}
